import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import EditableTable from "components/smea/Table/EditableTable";
import ConfirmationModal from "modals/smea/miscellaneous/ConfirmationModal";
import useAxiosPrivate from "contexts/interceptors/axios";

export default function MELCsTable({
  data,
  setSelectedData,
  loadingState,
  updateTableFunction,
}) {
  const axiosPrivate = useAxiosPrivate();
  const [selectedMELC, setSelectedMELC] = useState();
  const [rowToDelete, setRowToDelete] = useState();

  const [open, setOpen] = useState(false);
  const [promptResponse, setPromptResponse] = useState(null);
  const [submit, setSubmit] = useState(false);
  const [submitKind, setSubmitKind] = useState("");
  const [promptDesc, setPromptDesc] = useState("");

  const [loading, setLoading] = useState(false);

  setSelectedData(selectedMELC);

  useEffect(() => {
    if (rowToDelete) {
      setPromptDesc("Are you sure you want to delete this data?");
      setSubmitKind("delete");
      setOpen(true);
    }
  }, [rowToDelete]);

  useEffect(() => {
    if (!open && submit && promptResponse && rowToDelete) {
      setLoading(true);

      axiosPrivate
        .delete(`/competency/deleteMelc/${rowToDelete[0]?.id}`)
        .then(() => {
          alert("Competency deleted successfully");
          setRowToDelete(null);
          setSubmit(false);
          updateTableFunction();
        })
        .catch((err) => {
          alert(err?.message);
          setRowToDelete(null);
          setSubmit(false);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [submit, promptResponse]);

  const columns = [
    { field: "schoolYear", headerName: "School Year", width: 130 },
    // { field: "id", headerName: "ID", width: 70 },
    { field: "competencyNo", headerName: "Competency No", width: 130 },
    { field: "competencyDesc", headerName: "Competency", width: 450 },
    {
      field: "week",
      headerName: "Week No",
      width: 130,
    },
    {
      field: "gradeLevel",
      headerName: "Grade Level",
      width: 130,
    },
    {
      field: "subject",
      headerName: "Subject",
      width: 250,
      valueGetter: (params) => {
        const subject = params.value;

        return subject?.name;
      },
    },
    {
      field: "component",
      headerName: "Component",
      width: 130,
      valueGetter: (params) => {
        const component = params.value;

        return component?.name;
      },
    },
    {
      field: "quarter",
      headerName: "Quarter",
      width: 150,
      valueGetter: (params) => {
        if (params.value === 1) {
          return "First Quarter";
        }
        if (params.value === 2) {
          return "Second Quarter";
        }
        if (params.value === 3) {
          return "Third Quarter";
        }
        if (params.value === 4) {
          return "Fourth Quarter";
        }
        return null;
      },
    },
  ];

  return (
    <Box>
      <ConfirmationModal
        open={open}
        handleClose={() => setOpen(false)}
        setPromptResponse={setPromptResponse}
        setSubmit={setSubmit}
        submitKind={submitKind}
        promptDesc={promptDesc}
      />
      <EditableTable
        data={data}
        columns={columns}
        checkbox
        loading={loading || loadingState}
        singleSelect
        setSelectedData={setSelectedMELC}
        rowToDelete={setRowToDelete}
        height="60vh"
        remove
        showSearch
      />
    </Box>
  );
}
